<template>
	<div class="export-popi">
		<b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>

		<h1>Export Direct Purchase</h1>

		<p class="description">
			This page will export the Direct Purchases.
		</p>

		<div class="single-text-wrapper">
			<b-field label="Direct Purchase Number (Optional)">
				<b-input v-model="dpNumber" placeholder="Direct Purchase Number" @keyup.native.enter="exportReturn"></b-input>
			</b-field>

			<b-field label="Select Shop (Optional)" v-if="displayShopSelection">
				<b-autocomplete
					v-model="shopsSuggestions"
					:data="filteredShops"
					:open-on-focus="true"
					placeholder="Shop"
					field="name"
					@select="option => (selectedShop = option)"
					class="shopAutoComplete"
				>
					<template slot="empty">No results found</template>
				</b-autocomplete>
			</b-field>

			<b-field label="Select Brand (Optional)" v-if="displayBrandSelection">
				<b-autocomplete
					v-model="brandSuggestions"
					:data="filteredBrands"
					:open-on-focus="true"
					placeholder="Brand"
					field="name"
					@select="option => (selectedBrand = option)"
					class="brandAutocomplete"
				>
					<template slot="empty">No results found</template>
				</b-autocomplete>
			</b-field>
		</div>

		<div class="datepickerWrapper">
			<b-field label="Starting Date">
				<b-datepicker :date-formatter="dateFormatter" placeholder="Click to select..." v-model="fromDate" icon="calendar-today">
					<button class="button is-danger" @click="fromDate = null">
						<b-icon icon="close"></b-icon>
						<span>Clear</span>
					</button>
				</b-datepicker>
			</b-field>

			<b-field label="Ending Date">
				<b-datepicker
					:date-formatter="dateFormatter"
					placeholder="Click to select..."
					v-model="toDate"
					icon="calendar-today"
					:min-date="minDate"
					:max-date="maxDate"
				>
					<button class="button is-danger" @click="toDate = null">
						<b-icon icon="close"></b-icon>
						<span>Clear</span>
					</button></b-datepicker
				>
			</b-field>
		</div>

		<div class="button-container">
			<div class="big-button" @click="exportReturn()">
				Export
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'exportDirectPurchase',
	data: function() {
		return {
			limit: 20,
			fromDate: null,
			toDate: null,
			minDate: null,
			maxDate: null,
			dpNumber: null,
			isLoading: false,
			shops: [],
			shopsSuggestions: '',
			selectedShop: null,
			brands: [],
			selectedBrand: null,
			brandSuggestions: '',
			displayShopSelection: true,
			displayBrandSelection: true,
			statusText: '',
			matchFound: true
		}
	},

	watch: {
		fromDate: function(data) {
			if (data !== null) {
				this.minDate = data
				// Removed as client requested
				// this.maxDate = new Date(data.getFullYear(), data.getMonth(), data.getDate() + 30)

				this.toDate = new Date(data.getFullYear(), data.getMonth(), data.getDate() + 1)
			} else {
				this.toDate = null
			}
		},

		selectedShop: function(data) {
			if (data !== null) {
				this.displayBrandSelection = false
			} else {
				this.displayBrandSelection = true
			}
		},

		selectedBrand: function(data) {
			if (data !== null) {
				this.displayShopSelection = false
			} else {
				this.displayShopSelection = true
			}
		}
	},

	computed: {
		filteredShops() {
			return this.shops.filter(option => {
				return (
					option.name
						.toString()
						.toLowerCase()
						.indexOf(this.shopsSuggestions.toLowerCase()) >= 0
				)
			})
		},

		filteredBrands() {
			return this.brands.filter(option => {
				return (
					option.name
						.toString()
						.toLowerCase()
						.indexOf(this.brandSuggestions.toLowerCase()) >= 0
				)
			})
		}
	},

	mounted: async function() {
		await this.getShops()
		await this.getBrands()
	},

	methods: {
		// Export products on user click
		exportReturn: async function() {
			// Make sure fromDate is not empty
			if (this.fromDate == null && (this.returnNumber == null || this.returnNumber == '')) {
				this.$swal.fire({
					icon: 'error',
					title: 'Error...',
					text: 'Please enter Starting date'
				})

				return
			}

			this.isLoading = true

			if (this.selectedBrand) {
				this.matchFound = false
			}

			const data = {
				limit: this.limit,
				populate: ['author', 'shop'],
				sort: {
					createdAt: 'desc'
				}
			}

			if (this.dpNumber !== null && this.dpNumber !== '') {
				data.code = this.dpNumber
			}

			if (this.selectedShop) {
				data.shop = this.selectedShop._id
			}

			if (this.fromDate) {
				data.time = {}
				data.time.updatedAt = {
					$gte: this.$moment(this.fromDate)
						.set({ hour: 0 })
						.format('x')
				}

				if (this.toDate) {
					data.time.updatedAt.$lte = this.$moment(this.toDate)
						.set({ hour: 23 })
						.format('x')
				}
			}

			let dplist = []

			const result = await this.$api.getDirectPurchase({ data })

			if (result !== undefined && result.data.total > 0) {
				result.data.list.map(data => {
					dplist.push(data)
				})

				// Loop more to get full results
				if (result.data.total > this.limit) {
					var totalLoop = Math.ceil(result.data.total / this.limit)

					var i
					var skip

					// Loop all the pagers
					for (i = 1; i < totalLoop; i++) {
						skip = i * this.limit

						data.skip = skip

						const result = await this.$api.getDirectPurchase({ data })

						if (result) {
							result.data.list.map(data => {
								dplist.push(data)
							})
						}
					}
				}

				if (dplist.length > 0) {
					for (let result in dplist) {
						let direct_purchase = dplist[result]._id

						dplist[result].products = []

						let data = {
							limit: 1000,
							direct_purchase,
							populate: ['product', 'supplier']
						}

						const apiGetDPDetail = await this.$api.getDirectPurchaseDetail({ data })

						if (apiGetDPDetail !== undefined) {
							if (this.selectedBrand) {
								if (apiGetDPDetail.data.count > 0 && apiGetDPDetail.data.list[0].product.brand == this.selectedBrand._id) {
									this.matchFound = true

									apiGetDPDetail.data.list.map(dpItem => {
										dplist[result].products.push(dpItem)
									})
								}
							} else {
								apiGetDPDetail.data.list.map(dpItem => {
									dplist[result].products.push(dpItem)
								})
							}
						}
					}
				}

				if (this.matchFound) {
					this.generateCSV(dplist)
				} else {
					this.isLoading = false
					this.$swal.fire({
						icon: 'error',
						title: 'Error...',
						text: 'Nothing found!'
					})
				}
			} else {
				this.isLoading = false
				this.$swal.fire({
					icon: 'info',
					title: 'Oops...',
					text: 'Nothing found!'
				})

				return
			}
		},

		generateCSV: function(dplist) {
			let export_csv = ''

			// Loop data
			dplist.map(data => {
				if (data.products.length > 0) {
					export_csv += 'DP CODE,DATE,TIME,BD CODE,BARCODE,NAME,BRAND NAME,BRAND CODE,BRANCH,ADMIN NAME,DATE,QUANTITY,PRICE,NET AMOUNT,REMARK\r\n'

					let total_quantity = 0
					let total_amount = 0

					// Map all the transfer products
					data.products.map(items => {
						let matchedBrand = this.brands.filter(brand => {
							return brand._id == items.product.brand
						})

						// const product_price =
						// 	items.product.commission > 0 || items.product.original_price < 2 ? items.product.price : items.product.original_price

						let product_price = items.price

						const dest_name = data.shop ? data.shop.name : data.author.name

						const toAdd = [
							data.code,
							this.$moment(items.createdAt).format('DD/MM/YY'),
							this.$moment(items.createdAt).format('hh:mm a'),
							items.product.bd_code,
							items.product.barcode,
							'"' + items.product.name + '"',
							matchedBrand[0].name,
							matchedBrand[0].code,
							// data.shop.name,
							dest_name,
							data.author.name,
							this.$moment(data.createdAt).format('DD/MM/YY hh:mm a'),
							items.qty,
							product_price,
							product_price * items.qty,
							items.remark
						]

						total_quantity += items.qty
						total_amount += product_price * items.qty

						let row = toAdd.join(',')

						export_csv += row + '\r\n'
					})

					export_csv += ',,,,,,,,,,Total,' + total_quantity + ',,' + total_amount

					export_csv += '\r\n\r\n'
				}
			})

			this.isLoading = false

			var csvData = new Blob([export_csv], { type: 'text/csv' }) //new way
			var csvUrl = URL.createObjectURL(csvData)

			var link = document.createElement('a')
			link.setAttribute('href', csvUrl)
			link.setAttribute('download', 'Export_Direct_Purchase.csv')
			document.body.appendChild(link) // Required for FF

			link.click()
			link.remove()

			// Reset all the fields
			this.fromDate = null
			this.toDate = null
			this.minDate = null
			this.returnNumber = null
		},

		// For calender format
		dateFormatter(dt) {
			return dt.toLocaleDateString('en-GB')
		},

		// Get list of shops
		getShops: async function() {
			const apiGetShops = await this.$api.getShops({})

			this.shops = apiGetShops.data.list
		},

		// Get all the brands
		getBrands: async function() {
			const data = {
				limit: 2000,
				sort: {
					name: 'asc'
				}
			}
			const apiGetBrands = await this.$api.getBrand({ data })

			if (apiGetBrands !== undefined) {
				this.brands = apiGetBrands.data.list
			}
		}
	}
}
</script>

<style scoped>
@import '../styles/GeneralStyles.css';
</style>
